import { useMemo, useState } from 'react';
import {
  DEFAULT_BODY_RESULT_OPTIONS,
  buildResultNumberMap,
  getNumberedResultOptions,
  mostSevereStatus,
  readStatusList,
} from '../utils/resultOptions';

// هذه القائمة ليست للعرض فقط: resolvedStyle يستخدمها بوابةً للأنماط المعروفة،
// فأي نمط غائب عنها يسقط على سيدان مهما كان مرسومًا ومدعومًا أسفل الملف.
const STYLE_LABELS = {
  sedan: 'سيدان',
  suv: 'SUV',
  coupe: 'كوبيه',
  pickup: 'بيك أب',
  hatchback: 'هاتشباك',
  van: 'فان',
  chassis_cab: 'شاسي كاب',
  box_truck: 'شاحنة صندوق',
  trailer: 'تريلا',
};

const BODY_STYLE_REFERENCE_ASSETS = {
  sedan: '/sedan.svg',
  suv: '/suv.svg',
  van: '/van.svg',
};

const SEDAN_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20sedan.svg', width: 600, height: 289, viewBox: '0 0 600 289' },
  front: { src: '/front%20sedan.svg', width: 277, height: 214, viewBox: '0 0 277 214' },
  rear: { src: '/back%20sedan.svg', width: 285, height: 230, viewBox: '0 0 285 230' },
  left: { src: '/left%20sedan.svg', width: 600, height: 192, viewBox: '0 0 600 192' },
};

const HATCHBACK_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20Hatchback%20.svg', width: 2400, height: 1500, viewBox: '0 0 2400 1500' },
  front: { src: '/front%20Hatchback%20.svg', width: 1624, height: 1504, viewBox: '0 0 1624 1504' },
  rear: { src: '/back%20Hatchback%20.svg', width: 1628, height: 1496, viewBox: '0 0 1628 1496' },
  left: { src: '/left%20Hatchback%20.svg', width: 2400, height: 1132, viewBox: '0 0 2400 1132' },
  right: { src: '/right%20Hatchback%20.svg', width: 2400, height: 1132, viewBox: '0 0 2400 1132' },
};

const PICKUP_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20Pickup.svg', width: 2400, height: 900, viewBox: '0 0 2400 900' },
  front: { src: '/front%20Pickup.svg', width: 1732, height: 1444, viewBox: '0 0 1732 1444' },
  rear: { src: '/back%20Pickup.svg', width: 1836, height: 1552, viewBox: '0 0 1836 1552' },
  left: { src: '/left%20Pickup.svg', width: 2400, height: 992, viewBox: '0 0 2400 992' },
  right: { src: '/right%20Pickup.svg', width: 2400, height: 1436, viewBox: '0 0 2400 1436' },
};

const VAN_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20van.svg', width: 2400, height: 1000, viewBox: '0 0 2400 1000' },
  front: { src: '/front%20van.svg', width: 1608, height: 1576, viewBox: '0 0 1608 1576' },
  rear: { src: '/back%20van.svg', width: 1628, height: 1552, viewBox: '0 0 1628 1552' },
  left: { src: '/left%20van.svg', width: 2400, height: 1456, viewBox: '0 0 2400 1456' },
  right: { src: '/right%20van.svg', width: 2400, height: 1044, viewBox: '0 0 2400 1044' },
};

const SUV_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20suv.svg', width: 2400, height: 1656, viewBox: '0 0 2400 1656' },
  front: { src: '/front%20suv.svg', width: 1632, height: 1216, viewBox: '0 0 1632 1216' },
  rear: { src: '/back%20suv.svg', width: 1600, height: 1232, viewBox: '0 0 1600 1232' },
  left: { src: '/left%20suv.svg', width: 2400, height: 1052, viewBox: '0 0 2400 1052' },
  right: { src: '/right%20suv.svg', width: 2400, height: 1056, viewBox: '0 0 2400 1056' },
};

const COUPE_VIEW_REFERENCE_ASSETS = {
  top: { src: '/Top%20view%20Coupe.svg', width: 600, height: 247, viewBox: '0 0 600 247' },
  front: { src: '/Front%20view%20Coupe.svg', width: 484, height: 321, viewBox: '0 0 484 321' },
  rear: { src: '/Back%20view%20Coupe.svg', width: 527, height: 337, viewBox: '0 0 527 337' },
  left: { src: '/Left%20side%20view%20Coupe.svg', width: 600, height: 172, viewBox: '0 0 600 172' },
};

const CHASSIS_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20chassis.svg', width: 1613, height: 615, viewBox: '0 0 1613 615' },
  front: { src: '/front%20chassis.svg', width: 600, height: 498, viewBox: '0 0 600 498' },
  rear: { src: '/back%20chassis.svg', width: 600, height: 440, viewBox: '0 0 600 440' },
  left: { src: '/left%20chassis.svg', width: 1616, height: 518, viewBox: '0 0 1616 518' },
  right: { src: '/right%20chassis.svg', width: 1616, height: 518, viewBox: '0 0 1616 518' },
};

const TRAILER_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20trailer.svg', width: 293, height: 287, viewBox: '0 0 293 287' },
  front: { src: '/front%20trailer.svg', width: 289, height: 341, viewBox: '0 0 289 341' },
  rear: { src: '/back%20trailer.svg', width: 287, height: 390, viewBox: '0 0 287 390' },
  left: { src: '/left%20trailer.svg', width: 606, height: 342, viewBox: '0 0 606 342' },
  right: { src: '/right%20trailer.svg', width: 605, height: 388, viewBox: '0 0 605 388' },
};

const TRUCK_VIEW_REFERENCE_ASSETS = {
  top: { src: '/top%20truck.svg', width: 733, height: 253, viewBox: '0 0 733 253' },
  front: { src: '/front%20truck.svg', width: 252, height: 347, viewBox: '0 0 252 347' },
  rear: { src: '/back%20truck.svg', width: 252, height: 354, viewBox: '0 0 252 354' },
  left: { src: '/left%20truck.svg', width: 700, height: 357, viewBox: '0 0 700 357' },
  right: { src: '/right%20truck.svg', width: 704, height: 328, viewBox: '0 0 704 328' },
};

const STYLE_VIEW_REFERENCE_ASSETS = {
  box_truck: TRUCK_VIEW_REFERENCE_ASSETS,
  trailer: TRAILER_VIEW_REFERENCE_ASSETS,
  chassis_cab: CHASSIS_VIEW_REFERENCE_ASSETS,
  coupe: COUPE_VIEW_REFERENCE_ASSETS,
  sedan: SEDAN_VIEW_REFERENCE_ASSETS,
  hatchback: HATCHBACK_VIEW_REFERENCE_ASSETS,
  pickup: PICKUP_VIEW_REFERENCE_ASSETS,
  van: VAN_VIEW_REFERENCE_ASSETS,
  suv: SUV_VIEW_REFERENCE_ASSETS,
};

function rasterAssetPath(src) {
  return src ? src.replace(/\.svg$/i, '.png') : src;
}

function resolveAssetForMode(asset, preferRasterAssets) {
  if (!asset || !preferRasterAssets) return asset;
  return { ...asset, src: rasterAssetPath(asset.src) };
}

const COUPE_TOP_BASE_SIZE = { width: 340, height: 160 };
const COUPE_FRONT_BASE_SIZE = { width: 170, height: 150 };
const COUPE_REAR_BASE_SIZE = { width: 170, height: 150 };
const COUPE_SIDE_BASE_SIZE = { width: 440, height: 180 };

// textColor: لون رقم الحالة داخل الدائرة — الأبيض غير مقروء على الأصفر والرمادي الفاتح.
const STATUS_META = {
  good: { label: 'جيد', fill: '#22c55e', stroke: '#15803d', baseOpacity: 0.55, textColor: '#ffffff' },
  scratch: { label: 'خدش', fill: '#f97316', stroke: '#ea580c', baseOpacity: 0.55, textColor: '#ffffff' },
  damage: { label: 'ضرر', fill: '#facc15', stroke: '#ca8a04', baseOpacity: 0.55, textColor: '#1f2937' },
  sprayed: { label: 'مرشوش', fill: '#a855f7', stroke: '#7e22ce', baseOpacity: 0.55, textColor: '#ffffff' },
  riveted: { label: 'مسمكر', fill: '#0ea5e9', stroke: '#0369a1', baseOpacity: 0.58, textColor: '#ffffff' },
  replaced: { label: 'مبدل', fill: '#ec4899', stroke: '#be185d', baseOpacity: 0.58, textColor: '#ffffff' },
  defect: { label: 'تالف', fill: '#dc2626', stroke: '#991b1b', baseOpacity: 0.6, textColor: '#ffffff' },
  unknown: { label: 'غير محدد', fill: '#cbd5e1', stroke: '#64748b', baseOpacity: 0.18, textColor: '#334155' },
};

// يختار لون نص مقروءًا فوق أي لون خلفية يضبطه المسؤول.
function readableTextColor(hexColor, fallback = '#ffffff') {
  const color = String(hexColor || '').trim().replace('#', '');
  if (![3, 6].includes(color.length)) return fallback;

  const expanded = color.length === 3
    ? color.split('').map((char) => `${char}${char}`).join('')
    : color;

  const red = parseInt(expanded.slice(0, 2), 16);
  const green = parseInt(expanded.slice(2, 4), 16);
  const blue = parseInt(expanded.slice(4, 6), 16);
  if ([red, green, blue].some(Number.isNaN)) return fallback;

  return (red * 299 + green * 587 + blue * 114) / 1000 > 160 ? '#1f2937' : '#ffffff';
}

const TRAILER_FRONT_POLYGONS = {
  roof: '58,2 234,2 234,78 58,78',
  front_windshield: '50,82 240,82 240,156 50,156',
  hood: '50,158 240,158 240,244 50,244',
  front_bumper: '35,246 256,246 256,316 35,316',
  left_front_fender: '6,88 48,88 48,314 6,314',
  right_front_fender: '242,88 284,88 284,314 242,314',
};

// من الخلف يظهر الشاسيه والخامسة فقط؛ جدار الكابينة ليس منطقة فحص.
const TRAILER_REAR_POLYGONS = {
  cargo: '30,282 256,282 256,345 30,345',
  rear_bumper: '30,345 256,345 256,372 30,372',
};

// كابينة ببابين وشاسيه خلفي عليه الخامسة: لا أبواب خلفية ولا جنب ولا رفرف خلفي.
const TRAILER_SIDE_LAYOUT = {
  front_bumper: { left: '0%', top: '70%', width: '5.5%', height: '20%' },
  front_fender: { left: '13%', top: '62%', width: '20%', height: '36%' },
  front_door: { left: '8%', top: '16%', width: '27%', height: '47%' },
  rear_chassis: { left: '35%', top: '62%', width: '58%', height: '30%' },
  rear_bumper: { left: '93%', top: '68%', width: '6%', height: '22%' },
};

const TRUCK_FRONT_POLYGONS = {
  rear_box: '20,8 234,8 234,150 20,150',
  front_windshield: '38,155 202,155 202,210 38,210',
  hood: '33,212 208,212 208,283 33,283',
  front_bumper: '28,283 218,283 218,332 28,332',
  left_front_fender: '6,198 40,198 40,330 6,330',
  right_front_fender: '212,198 246,198 246,330 212,330',
};

// من الخلف لا يظهر إلا باب الصندوق والصدام، وهما وحدهما محل الفحص.
const TRUCK_REAR_POLYGONS = {
  cargo: '25,18 226,18 226,288 25,288',
  rear_bumper: '28,288 226,288 226,332 28,332',
};

// كابينة ببابين وصندوق خلفي واحد: لا أبواب خلفية ولا جنب ولا رفرف خلفي.
const TRUCK_SIDE_LAYOUT = {
  front_bumper: { left: '0%', top: '76%', width: '6%', height: '17%' },
  front_fender: { left: '15%', top: '71%', width: '17%', height: '29%' },
  front_door: { left: '20%', top: '40%', width: '13%', height: '31%' },
  rear_box: { left: '33%', top: '9%', width: '60%', height: '78%' },
  rear_bumper: { left: '93%', top: '80%', width: '6.5%', height: '13%' },
};

const CHASSIS_FRONT_POLYGONS = {
  front_bumper: '60,332 540,332 566,470 34,470',
  hood: '96,186 504,186 486,330 114,330',
  front_windshield: '108,30 492,30 476,182 124,182',
  left_front_fender: '18,176 92,166 108,468 30,468',
  right_front_fender: '582,176 508,166 492,468 570,468',
};

// من الخلف لا يظهر إلا الشاسيه العاري وكمرته، وهما وحدهما محل الفحص.
const CHASSIS_REAR_POLYGONS = {
  cargo: '176,258 424,258 424,380 176,380',
  rear_bumper: '146,382 454,382 454,422 146,422',
};

// كابينة ببابين وشاسيه خلفي واحد: لا أبواب خلفية ولا جنب ولا رفرف خلفي.
const CHASSIS_SIDE_LAYOUT = {
  front_bumper: { left: '1%', top: '72%', width: '5%', height: '20%' },
  front_fender: { left: '7%', top: '55%', width: '14%', height: '36%' },
  front_door: { left: '23%', top: '32%', width: '18%', height: '56%' },
  rear_chassis: { left: '41%', top: '84%', width: '51%', height: '13%' },
  rear_bumper: { left: '92%', top: '84%', width: '6%', height: '13%' },
};

const SIDE_EXCLUDED_SLOTS = new Set(['cargo', 'hood', 'front_windshield', 'rear_windshield', 'roof']);

const MARKER_OFFSETS = {
  top: {
    front_bumper: { dx: 0, dy: -2 },
    rear_bumper: { dx: 0, dy: 2 },
    hood: { dx: 0, dy: 2 },
    trunk: { dx: 0, dy: -1 },
    tailgate: { dx: 0, dy: -1 },
    rear_hatch: { dx: 0, dy: -1 },
    roof: { dx: 0, dy: 1 },
    left_front_door: { dx: -1, dy: 0 },
    right_front_door: { dx: 1, dy: 0 },
    left_rear_door: { dx: -1, dy: 0 },
    right_rear_door: { dx: 1, dy: 0 },
  },
  front: {
    front_bumper: { dx: 0, dy: 2 },
    hood: { dx: 0, dy: -1 },
    front_windshield: { dx: 0, dy: -1 },
    left_front_fender: { dx: -1, dy: 1 },
    right_front_fender: { dx: 1, dy: 1 },
  },
  rear: {
    rear_bumper: { dx: 0, dy: 2 },
    trunk: { dx: 0, dy: 0 },
    tailgate: { dx: 0, dy: 0 },
    rear_hatch: { dx: 0, dy: 0 },
    rear_windshield: { dx: 0, dy: -1 },
    left_side_panel: { dx: -1, dy: 1 },
    right_side_panel: { dx: 1, dy: 1 },
  },
  'left-side': {
    left_front_door: { dx: 0, dy: 1 },
    left_rear_door: { dx: 0, dy: 1 },
    left_front_fender: { dx: -1, dy: 0 },
    left_rear_fender: { dx: -1, dy: 0 },
  },
  'right-side': {
    right_front_door: { dx: 0, dy: 1 },
    right_rear_door: { dx: 0, dy: 1 },
    right_front_fender: { dx: 1, dy: 0 },
    right_rear_fender: { dx: 1, dy: 0 },
  },
};

const BASE_SIDE_LAYOUT = {
  front_bumper: { left: '2%', top: '62%', width: '9%', height: '12%' },
  front_fender: { left: '11%', top: '54%', width: '13%', height: '20%' },
  hood: { left: '18%', top: '43%', width: '18%', height: '16%' },
  front_windshield: { left: '35%', top: '39%', width: '11%', height: '13%' },
  roof: { left: '44%', top: '28%', width: '24%', height: '11%' },
  rear_windshield: { left: '67%', top: '39%', width: '9%', height: '13%' },
  front_door: { left: '24%', top: '57%', width: '20%', height: '20%' },
  rear_door: { left: '44%', top: '57%', width: '20%', height: '20%' },
  side_panel: { left: '64%', top: '57%', width: '13%', height: '20%' },
  rear_fender: { left: '76%', top: '57%', width: '11%', height: '20%' },
  cargo: { left: '74%', top: '45%', width: '15%', height: '18%' },
  rear_bumper: { left: '88%', top: '63%', width: '9%', height: '12%' },
};

const SIDE_LAYOUT_OVERRIDES = {
  suv: {
    front_bumper: { left: '1.5%', top: '63%', width: '10%', height: '13%' },
    front_fender: { left: '10.5%', top: '53%', width: '14%', height: '22%' },
    hood: { left: '17%', top: '42%', width: '17%', height: '16%' },
    front_windshield: { left: '33%', top: '36%', width: '12%', height: '15%' },
    roof: { left: '44%', top: '22%', width: '27%', height: '14%' },
    rear_windshield: { left: '68%', top: '35%', width: '10%', height: '15%' },
    front_door: { left: '24%', top: '55%', width: '17%', height: '22%' },
    rear_door: { left: '41%', top: '55%', width: '19%', height: '22%' },
    side_panel: { left: '60%', top: '55%', width: '15%', height: '22%' },
    rear_fender: { left: '74%', top: '55%', width: '12%', height: '22%' },
    cargo: { left: '77%', top: '38%', width: '12%', height: '20%' },
    rear_bumper: { left: '89%', top: '63%', width: '8%', height: '13%' },
  },
  pickup: {
    rear_door: { left: '44%', top: '57%', width: '16%', height: '20%' },
    side_panel: { left: '60%', top: '57%', width: '17%', height: '20%' },
    cargo: { left: '75%', top: '50%', width: '14%', height: '12%' },
  },
  hatchback: {
    cargo: { left: '73%', top: '38%', width: '16%', height: '24%' },
  },
  van: {
    hood: { left: '14%', top: '42%', width: '14%', height: '16%' },
    roof: { left: '37%', top: '16%', width: '33%', height: '13%' },
    front_door: { left: '23%', top: '56%', width: '16%', height: '21%' },
    rear_door: { left: '39%', top: '56%', width: '27%', height: '21%' },
    side_panel: { left: '66%', top: '56%', width: '12%', height: '21%' },
    cargo: { left: '77%', top: '39%', width: '13%', height: '22%' },
  },
};

const TOP_POLYGONS = {
  rear_bumper: '10,54 30,44 40,50 40,110 30,116 10,106',
  cargo: '40,44 84,30 98,40 98,120 84,130 40,116',
  rear_windshield: '98,40 124,34 136,44 136,116 124,126 98,120',
  roof: '136,30 204,24 218,34 218,126 204,136 136,130',
  front_windshield: '218,44 244,34 256,40 256,120 244,126 218,116',
  hood: '256,40 300,30 314,44 314,116 300,130 256,120',
  front_bumper: '314,50 330,44 334,54 334,106 330,116 314,110',
};

const FRONT_POLYGONS = {
  front_bumper: '28,104 142,104 150,126 20,126',
  hood: '36,66 134,66 122,100 48,100',
  front_windshield: '54,38 116,38 106,64 64,64',
  left_front_fender: '18,76 42,70 48,102 24,112',
  right_front_fender: '152,76 128,70 122,102 146,112',
};

const REAR_POLYGONS = {
  rear_bumper: '24,104 146,104 154,126 16,126',
  cargo: '38,66 132,66 124,100 46,100',
  rear_windshield: '54,38 116,38 108,62 62,62',
  left_side_panel: '14,78 40,72 46,102 22,112',
  right_side_panel: '156,78 130,72 124,102 148,112',
};

const HATCHBACK_TOP_POLYGONS = {
  rear_bumper: '86,418 224,382 266,448 266,1050 220,1116 84,1082',
  cargo: '266,238 786,196 878,260 878,1242 786,1306 266,1264',
  rear_windshield: '878,284 1048,244 1120,294 1120,1210 1048,1260 878,1222',
  roof: '1120,206 1712,182 1812,236 1812,1268 1712,1324 1120,1300',
  front_windshield: '1812,286 1986,246 2060,290 2060,1210 1986,1252 1812,1220',
  hood: '2060,354 2302,318 2372,374 2372,1134 2302,1188 2060,1152',
  front_bumper: '2372,540 2392,526 2398,602 2398,902 2392,978 2372,964',
};

const HATCHBACK_FRONT_POLYGONS = {
  front_bumper: '206,1138 1416,1138 1506,1342 118,1342',
  hood: '292,696 1330,696 1226,1050 396,1050',
  front_windshield: '458,334 1182,334 1098,662 542,662',
  left_front_fender: '110,802 334,742 402,1090 182,1204',
  right_front_fender: '1514,802 1290,742 1222,1090 1442,1204',
};

const HATCHBACK_REAR_POLYGONS = {
  rear_bumper: '202,1126 1422,1126 1510,1336 114,1336',
  cargo: '306,658 1318,658 1214,1032 410,1032',
  rear_windshield: '462,256 1168,256 1086,612 544,612',
  left_side_panel: '112,790 334,728 402,1084 182,1202',
  right_side_panel: '1512,790 1290,728 1222,1084 1442,1202',
};

const PICKUP_TOP_POLYGONS = {
  rear_bumper: '70,326 182,296 214,338 214,560 178,602 72,574',
  cargo: '214,238 792,182 888,234 888,668 792,720 214,654',
  rear_windshield: '888,244 1060,216 1132,264 1132,638 1060,684 888,656',
  roof: '1132,194 1508,174 1598,228 1598,674 1508,728 1132,704',
  front_windshield: '1598,252 1766,220 1842,254 1842,646 1766,680 1598,650',
  hood: '1842,236 2212,186 2302,246 2302,654 2212,714 1842,664',
  front_bumper: '2302,334 2360,312 2384,362 2384,542 2360,588 2302,566',
};

const PICKUP_FRONT_POLYGONS = {
  front_bumper: '236,1096 1494,1096 1572,1278 172,1278',
  hood: '328,666 1404,666 1280,1032 454,1032',
  front_windshield: '498,334 1238,334 1138,632 596,632',
  left_front_fender: '122,774 352,712 430,1054 194,1162',
  right_front_fender: '1610,774 1380,712 1302,1054 1538,1162',
};

const PICKUP_REAR_POLYGONS = {
  rear_bumper: '222,1162 1618,1162 1708,1378 132,1378',
  cargo: '362,714 1472,714 1358,1086 476,1086',
  rear_windshield: '566,350 1270,350 1176,650 660,650',
  left_side_panel: '140,830 384,764 462,1100 226,1206',
  right_side_panel: '1690,830 1446,764 1368,1100 1604,1206',
};

// الشاسي كاب: المقدمة إلى اليسار. أسماء الشرائح معكوسة عمدًا لأن
// resolveTopZoneKey يعكسها (rear_bumper يصير front_bumper وهكذا).
// التريلا: قاطرة بلا مقطورة، المقدمة إلى اليسار بعد تدوير المصدر 90 درجة.
const TRAILER_TOP_POLYGONS = {
  rear_bumper: '2,40 45,30 45,258 2,248',
  cargo: '45,26 78,22 78,266 45,262',
  rear_windshield: '78,20 105,18 105,270 78,268',
  roof: '105,16 290,14 290,274 105,272',
};

// شاحنة الصندوق: المقدمة إلى اليسار، والأسماء معكوسة كما في بقية خرائط المسقط العلوي.
const TRUCK_TOP_POLYGONS = {
  rear_bumper: '4,70 40,58 40,196 4,184',
  cargo: '40,42 100,34 100,220 40,212',
  rear_windshield: '100,32 160,28 160,226 100,222',
  roof: '160,26 236,24 236,228 160,226',
  hood: '236,26 700,24 700,228 236,226',
  front_bumper: '700,26 730,26 730,228 700,228',
};

const CHASSIS_TOP_POLYGONS = {
  rear_bumper: '14,230 78,196 78,428 14,394',
  cargo: '78,130 214,112 214,506 78,488',
  rear_windshield: '214,108 330,102 330,516 214,510',
  roof: '330,96 616,92 616,524 330,520',
  hood: '616,198 1552,196 1552,484 616,482',
  front_bumper: '1552,196 1606,196 1606,484 1552,484',
};

const VAN_TOP_POLYGONS = {
  rear_bumper: '54,334 176,314 212,356 212,644 176,688 54,666',
  cargo: '212,178 752,154 858,198 858,802 752,846 212,824',
  rear_windshield: '858,210 1046,190 1126,228 1126,772 1046,810 858,790',
  roof: '1126,132 1710,122 1806,168 1806,832 1710,878 1126,868',
  front_windshield: '1806,210 1984,194 2064,230 2064,770 1984,806 1806,790',
  hood: '2064,278 2288,246 2366,294 2366,706 2288,754 2064,722',
  front_bumper: '2366,366 2392,356 2398,398 2398,602 2392,644 2366,632',
};

const VAN_FRONT_POLYGONS = {
  front_bumper: '208,1186 1398,1186 1476,1394 130,1394',
  hood: '274,822 1336,822 1228,1112 382,1112',
  front_windshield: '396,302 1212,302 1126,778 482,778',
  left_front_fender: '114,838 324,780 372,1162 176,1258',
  right_front_fender: '1494,838 1284,780 1236,1162 1432,1258',
};

const VAN_REAR_POLYGONS = {
  rear_bumper: '188,1182 1438,1182 1510,1392 116,1392',
  cargo: '304,664 1324,664 1228,1116 400,1116',
  rear_windshield: '468,258 1166,258 1088,620 546,620',
  left_side_panel: '108,792 334,736 392,1130 188,1232',
  right_side_panel: '1518,792 1292,736 1234,1130 1438,1232',
};

const SUV_TOP_POLYGONS = {
  rear_bumper: '72,452 188,426 220,486 220,1170 186,1232 72,1200',
  cargo: '220,260 792,214 900,272 900,1384 792,1442 220,1398',
  rear_windshield: '900,284 1088,244 1178,290 1178,1360 1088,1406 900,1370',
  roof: '1178,190 1730,170 1820,220 1820,1436 1730,1488 1178,1466',
  front_windshield: '1820,290 2008,248 2098,292 2098,1360 2008,1406 1820,1368',
  hood: '2098,374 2310,330 2382,392 2382,1272 2310,1332 2098,1288',
  front_bumper: '2382,542 2396,528 2398,610 2398,1054 2394,1124 2382,1108',
};

const SUV_FRONT_POLYGONS = {
  front_bumper: '210,898 1418,898 1510,1098 122,1098',
  hood: '292,532 1334,532 1230,828 396,828',
  front_windshield: '448,198 1186,198 1106,488 526,488',
  left_front_fender: '104,610 314,570 372,872 176,982',
  right_front_fender: '1528,610 1318,570 1260,872 1456,982',
};

const SUV_REAR_POLYGONS = {
  rear_bumper: '192,938 1408,938 1494,1138 110,1138',
  cargo: '292,526 1308,526 1214,850 386,850',
  rear_windshield: '446,180 1154,180 1076,464 526,464',
  left_side_panel: '108,646 320,596 382,910 180,1018',
  right_side_panel: '1492,646 1280,596 1218,910 1420,1018',
};

const COUPE_SIDE_POLYGONS = {
  front_bumper: '14,98 58,94 78,102 72,124 28,126 12,116',
  front_fender: '56,74 118,70 148,82 142,112 92,126 54,108',
  hood: '94,82 162,76 184,88 176,106 110,110 94,98',
  front_windshield: '162,76 196,70 210,84 198,98 170,100',
  roof: '196,62 284,58 306,70 286,84 214,86 196,74',
  rear_windshield: '306,70 332,74 342,90 328,102 304,96',
  front_door: '156,76 332,72 350,86 338,130 176,136 148,112',
  side_panel: '338,92 412,88 426,98 420,126 346,130 332,114',
  rear_fender: '390,74 500,70 530,90 516,126 430,130 374,108',
  cargo: '470,76 560,74 578,88 568,102 492,104 462,92',
  rear_bumper: '520,98 584,96 598,108 584,126 530,128 512,116',
};

const SEDAN_SVG_VIEWBOX = '0 0 394.021 168.064';
const REFERENCE_SVG_VIEWBOX = '0 0 440 180';

const SEDAN_SIDE_PANELS = {
  front_bumper: '46,71 31,75 19,82 13,90 13,101 21,107 37,108 48,102 52,89 52,78',
  front_fender: '116,56 101,53 84,53 67,57 52,65 46,79 49,93 61,102 80,104 99,99 113,88 116,72',
  hood: '223,36 204,32 184,31 162,31 141,33 123,37 111,46 112,56 131,56 158,53 184,50 207,49 223,47',
  front_windshield: '177,31 159,31 141,34 124,41 111,49 118,55 134,53 151,48 166,41 176,35',
  roof: '286,18 268,15 247,13 225,12 202,12 180,13 160,15 148,19 153,27 175,28 202,28 230,27 255,26 279,24',
  rear_windshield: '338,37 325,31 311,27 296,24 281,24 269,27 269,40 278,46 291,51 307,55 323,55 331,49',
  front_door: '228,52 206,49 179,48 151,48 128,50 116,56 111,73 111,95 114,112 126,118 151,119 180,119 207,118 225,113 228,98 228,87',
  rear_door: '304,54 289,51 271,50 251,50 229,52 229,89 230,103 235,116 252,118 274,117 293,113 305,103 309,87 309,64',
  side_panel: '362,55 350,52 336,51 319,52 310,58 309,76 318,85 333,89 349,86 361,72',
  rear_fender: '381,71 372,70 360,72 351,79 350,93 357,101 369,103 379,98 383,88 383,78',
  cargo: '373,45 360,40 345,38 332,42 326,50 328,61 339,69 352,76 367,77 377,69 378,55',
  rear_bumper: '391,80 378,79 371,86 371,97 378,103 388,102 392,91',
};

function normalizeZoneKeyForStyle(zoneKey, bodyStyle) {
  if (!zoneKey) return zoneKey;

  if (bodyStyle === 'trailer' && ['trunk', 'rear_hatch', 'tailgate'].includes(zoneKey)) return 'rear_chassis';
  if (bodyStyle === 'box_truck' && ['trunk', 'rear_hatch', 'tailgate'].includes(zoneKey)) return 'rear_box';
  if (bodyStyle === 'chassis_cab' && ['trunk', 'rear_hatch', 'tailgate'].includes(zoneKey)) return 'rear_chassis';
  if (bodyStyle === 'hatchback' && zoneKey === 'trunk') return 'rear_hatch';
  if ((bodyStyle === 'pickup' || bodyStyle === 'van') && zoneKey === 'trunk') return 'tailgate';
  if (bodyStyle === 'sedan' && (zoneKey === 'rear_hatch' || zoneKey === 'tailgate')) return 'trunk';
  if (bodyStyle === 'suv' && zoneKey === 'tailgate') return 'trunk';

  return zoneKey;
}

function cargoZoneForStyle(bodyStyle) {
  if (bodyStyle === 'trailer') return 'rear_chassis';
  if (bodyStyle === 'box_truck') return 'rear_box';
  if (bodyStyle === 'chassis_cab') return 'rear_chassis';
  if (bodyStyle === 'hatchback') return 'rear_hatch';
  if (bodyStyle === 'pickup' || bodyStyle === 'van') return 'tailgate';
  return 'trunk';
}

function getSideLayout(bodyStyle) {
  return {
    ...BASE_SIDE_LAYOUT,
    ...(SIDE_LAYOUT_OVERRIDES[bodyStyle] || {}),
  };
}

function deriveConditionStatus(result, statusMeta = STATUS_META) {
  if (!result) return 'unknown';

  // عند اختيار أكثر من نتيجة، لون الجزء يتبع الأشد لأن الجزء لا يحمل إلا لونًا واحدًا.
  const selected = readStatusList(result).filter((status) => statusMeta[status]);
  if (selected.length) return mostSevereStatus(selected);

  if (result.condition_status && statusMeta[result.condition_status]) return result.condition_status;
  if (result.is_replaced) return 'replaced';
  if (result.is_riveted) return 'riveted';
  if (result.is_dented) return 'defect';
  if (result.is_sprayed) return 'sprayed';
  if (result.is_modified || result.is_loose || result.is_plastic || result.is_protected) {
    return 'damage';
  }
  // إلغاء تحديد كل الحالات يعيد الجزء إلى «غير محدد»، لا إلى «جيد».
  return 'unknown';
}

function statusRank(status, statusRankMap = {}) {
  return statusRankMap[status] ?? 0;
}

function getZoneStateMap(items, values, bodyStyle, statusMeta = STATUS_META, statusRankMap = {}) {
  const zoneStates = {};

  items.forEach((item) => {
    const zoneKey = normalizeZoneKeyForStyle(item.diagram_zone_key, bodyStyle);
    if (!zoneKey) return;

    const nextStatus = deriveConditionStatus(values[item.id], statusMeta);
    const currentStatus = zoneStates[zoneKey] || 'unknown';

    if (statusRank(nextStatus, statusRankMap) >= statusRank(currentStatus, statusRankMap)) {
      zoneStates[zoneKey] = nextStatus;
    }
  });

  return zoneStates;
}

function percent(value) {
  return Number.parseFloat(value.replace('%', ''));
}

// أصول الجانب الأيمن مقدمتها إلى اليمين، بينما تفترض نسب التخطيط أن المقدمة إلى اليسار.
// بلا هذا العكس تقع مناطق المقدمة على المؤخرة: نتيجة الباب الأمامي الأيمن تظهر على الباب الخلفي الأيمن.
function mirrorSideLayout(layout) {
  return Object.fromEntries(Object.entries(layout).map(([slot, rect]) => [
    slot,
    { ...rect, left: `${100 - percent(rect.left) - percent(rect.width)}%` },
  ]));
}

function layoutToRectParts(layout, width, height) {
  return Object.entries(layout).map(([slot, rect]) => ({
    slot,
    x: (percent(rect.left) / 100) * width,
    y: (percent(rect.top) / 100) * height,
    width: (percent(rect.width) / 100) * width,
    height: (percent(rect.height) / 100) * height,
  }));
}

function polygonMapToShapes(polygonMap) {
  return Object.entries(polygonMap).map(([slot, points]) => ({
    slot,
    type: 'polygon',
    points,
  }));
}

function scalePolygonPoints(points, scaleX, scaleY) {
  return points
    .split(' ')
    .filter(Boolean)
    .map((pair) => {
      const [x, y] = pair.split(',').map(Number);
      return `${(x * scaleX).toFixed(2)},${(y * scaleY).toFixed(2)}`;
    })
    .join(' ');
}

function scalePolygonMap(polygonMap, targetWidth, targetHeight, baseWidth, baseHeight) {
  const scaleX = targetWidth / baseWidth;
  const scaleY = targetHeight / baseHeight;

  return Object.fromEntries(
    Object.entries(polygonMap).map(([slot, points]) => [slot, scalePolygonPoints(points, scaleX, scaleY)]),
  );
}

function getInteractiveStyle(status, hovered, active, statusMeta) {
  const meta = statusMeta[status] || statusMeta.unknown;
  const isEmphasized = active || hovered;

  return {
    fill: '#ffffff',
    fillOpacity: isEmphasized ? 0.08 : 0.01,
    stroke: isEmphasized ? meta.stroke : '#94a3b8',
    strokeOpacity: isEmphasized ? 1 : 0.65,
    strokeWidth: isEmphasized ? 2.4 : 1.2,
  };
}

function parsePolygonPoints(points = '') {
  return points
    .split(' ')
    .filter(Boolean)
    .map((pair) => pair.split(',').map(Number))
    .filter(([x, y]) => Number.isFinite(x) && Number.isFinite(y));
}

function getPolygonCentroid(points) {
  if (!points?.length) return null;
  if (points.length < 3) return null;

  let signedArea = 0;
  let centroidX = 0;
  let centroidY = 0;

  for (let i = 0; i < points.length; i += 1) {
    const [x0, y0] = points[i];
    const [x1, y1] = points[(i + 1) % points.length];
    const cross = x0 * y1 - x1 * y0;
    signedArea += cross;
    centroidX += (x0 + x1) * cross;
    centroidY += (y0 + y1) * cross;
  }

  signedArea *= 0.5;
  if (Math.abs(signedArea) < 1e-7) return null;

  return {
    x: centroidX / (6 * signedArea),
    y: centroidY / (6 * signedArea),
  };
}

// 440 هو عرض الـ viewBox المرجعي الذي عوُيرت عليه أحجام العلامات أصلًا.
const MARKER_REFERENCE_WIDTH = 440;

function getMarkerScale(viewBox) {
  const parts = String(viewBox || '').trim().split(/[\s,]+/).map(Number);
  const width = parts.length === 4 && Number.isFinite(parts[2]) ? parts[2] : MARKER_REFERENCE_WIDTH;
  if (!width || width <= 0) return 1;
  return width / MARKER_REFERENCE_WIDTH;
}

function getShapeMarkerMetrics(shape, markerScale = 1) {
  if (shape.type === 'polygon') {
    const points = parsePolygonPoints(shape.points);
    if (!points.length) return { cx: 0, cy: 0, r: 8 };

    const xs = points.map(([x]) => x);
    const ys = points.map(([, y]) => y);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const centroid = getPolygonCentroid(points);
    const bboxCx = (minX + maxX) / 2;
    const bboxCy = (minY + maxY) / 2;
    const cx = Number.isFinite(centroid?.x) ? centroid.x : bboxCx;
    const cy = Number.isFinite(centroid?.y) ? centroid.y : bboxCy;
    const span = Math.max(maxX - minX, maxY - minY);
    const r = Math.max(16 * markerScale, Math.min(52 * markerScale, span * 0.3));

    return { cx, cy, r };
  }

  const cx = shape.x + shape.width / 2;
  const cy = shape.y + shape.height / 2;
  const span = Math.max(shape.width, shape.height);
  const shortSide = Math.min(shape.width, shape.height);

  // الحجم المرغوب للقراءة.
  const desired = Math.min(44 * markerScale, span * 0.32);
  // سقف الاتساع: يمنع فيضان العلامة خارج الأجزاء الشريطية الرفيعة
  // (مثل عتبات البيك أب) التي ارتفاعها أصغر بكثير من عرضها.
  const fitCap = shortSide * 0.85;
  // حد أدنى للقراءة، لكنه لا يتجاوز ما يتسع له الجزء نفسه.
  const floor = Math.min(15 * markerScale, fitCap);
  const r = Math.max(floor, Math.min(desired, fitCap));

  return { cx, cy, r };
}

function getMarkerOffset(viewId, zoneKey) {
  return MARKER_OFFSETS?.[viewId]?.[zoneKey] || { dx: 0, dy: 0 };
}

function partDomId(viewId, zoneKey) {
  return `inspection-part-${viewId}-${zoneKey}`;
}

function ViewCard({ title, children, className = '' }) {
  return (
    <div className={`rounded-2xl border bg-slate-50 p-3 ${className}`}>
      <div className="mb-2 text-sm font-semibold text-slate-600">{title}</div>
      {children}
    </div>
  );
}

function getBodyStyleReferenceAsset(bodyStyle) {
  return BODY_STYLE_REFERENCE_ASSETS[bodyStyle] || null;
}

function resolveTopZoneKey(slot, cargoZone) {
  const reversedTopMap = {
    rear_bumper: 'front_bumper',
    cargo: 'hood',
    rear_windshield: 'front_windshield',
    front_windshield: 'rear_windshield',
    hood: cargoZone,
    front_bumper: 'rear_bumper',
  };

  return reversedTopMap[slot] || slot;
}

function resolveSideZoneKey(slot, side, cargoZone) {
  if (slot === 'front_fender') return `${side}_front_fender`;
  if (slot === 'rear_fender') return `${side}_rear_fender`;
  if (slot === 'front_door') return `${side}_front_door`;
  if (slot === 'rear_door') return `${side}_rear_door`;
  if (slot === 'side_panel') return `${side}_side_panel`;
  if (slot === 'cargo') return cargoZone;
  return slot;
}

function TopSilhouette() {
  return (
    <>
      <path d="M42 80 C60 34, 120 14, 170 14 C220 14, 280 34, 298 80 C280 124, 220 146, 170 146 C120 146, 60 124, 42 80 Z" fill="none" stroke="#94a3b8" strokeWidth="4" />
      <rect x="65" y="38" width="58" height="84" rx="18" fill="none" stroke="#94a3b8" strokeWidth="3" />
      <rect x="124" y="29" width="92" height="102" rx="22" fill="none" stroke="#94a3b8" strokeWidth="3" />
      <rect x="217" y="38" width="58" height="84" rx="18" fill="none" stroke="#94a3b8" strokeWidth="3" />
    </>
  );
}

function FrontSilhouette() {
  return (
    <>
      <path d="M28 124 L38 62 C42 38 60 24 85 20 C110 24 128 38 132 62 L142 124" fill="none" stroke="#94a3b8" strokeWidth="4" />
      <path d="M48 60 L122 60" stroke="#94a3b8" strokeWidth="3" />
      <path d="M58 40 L112 40" stroke="#94a3b8" strokeWidth="3" />
      <path d="M48 74 L122 74" stroke="#94a3b8" strokeWidth="2.5" />
      <path d="M44 88 L126 88" stroke="#94a3b8" strokeWidth="2.5" />
      <circle cx="24" cy="104" r="10" fill="none" stroke="#94a3b8" strokeWidth="3" />
      <circle cx="146" cy="104" r="10" fill="none" stroke="#94a3b8" strokeWidth="3" />
    </>
  );
}

function RearSilhouette() {
  return (
    <>
      <path d="M28 124 L36 56 C40 34 58 22 85 20 C112 22 130 34 134 56 L142 124" fill="none" stroke="#94a3b8" strokeWidth="4" />
      <path d="M48 46 L122 46" stroke="#94a3b8" strokeWidth="3" />
      <path d="M42 70 L128 70" stroke="#94a3b8" strokeWidth="3" />
      <path d="M38 92 L132 92" stroke="#94a3b8" strokeWidth="3" />
      <circle cx="24" cy="104" r="10" fill="none" stroke="#94a3b8" strokeWidth="3" />
      <circle cx="146" cy="104" r="10" fill="none" stroke="#94a3b8" strokeWidth="3" />
    </>
  );
}

function SideSilhouette({ bodyStyle = 'sedan' }) {
  const roofPath = {
    sedan: 'M110 98 C140 72, 170 58, 220 56 L290 56 C330 58, 358 72, 392 98',
    suv: 'M98 98 C120 68, 152 48, 220 46 L300 46 C340 48, 376 66, 406 98',
    pickup: 'M116 98 C144 70, 170 56, 220 54 L266 54 C300 56, 322 70, 344 98',
    hatchback: 'M108 98 C138 68, 166 52, 224 50 L284 50 C336 52, 380 70, 410 98',
    van: 'M92 98 C108 54, 150 36, 242 34 L334 34 C378 34, 408 54, 420 98',
  }[bodyStyle] || 'M110 98 C140 72, 170 58, 220 56 L290 56 C330 58, 358 72, 392 98';

  return (
    <>
      <path d="M30 118 L52 118 C66 98 82 92 108 92 L368 92 C390 92 406 100 422 118 L430 118" fill="none" stroke="#94a3b8" strokeWidth="4" />
      <path d={roofPath} fill="none" stroke="#94a3b8" strokeWidth="4" />
      <path d="M46 118 C58 144, 78 156, 104 156 L340 156 C388 156, 410 142, 426 118" fill="none" stroke="#94a3b8" strokeWidth="4" />
      <path d="M145 96 L182 96" stroke="#94a3b8" strokeWidth="3" />
      <path d="M182 96 L182 144" stroke="#94a3b8" strokeWidth="3" />
      <path d="M260 96 L260 144" stroke="#94a3b8" strokeWidth="3" />
      <path d="M334 96 L334 144" stroke="#94a3b8" strokeWidth="3" />
      <circle cx="118" cy="156" r="28" fill="none" stroke="#64748b" strokeWidth="5" />
      <circle cx="350" cy="156" r="28" fill="none" stroke="#64748b" strokeWidth="5" />
    </>
  );
}

function InteractiveShape({
  shape,
  zoneKey,
  viewId,
  statusNumbers,
  zoneStates,
  hoveredKey,
  setHoveredKey,
  activeZoneKey,
  onPartSelect,
  mirrored = false,
  statusMeta,
  markerScale = 1,
}) {
  const status = zoneStates[zoneKey] || 'unknown';
  // الرقم المعروض على الجزء = رقم حالته في دليل الألوان (جيد = 1 ...).
  // الأجزاء غير المفحوصة تُعرض بعلامة استفهام لأنها بلا حالة.
  const statusNumber = statusNumbers?.[status] || '؟';
  const domId = partDomId(viewId, zoneKey);
  const interactive = Boolean(onPartSelect);
  const hoverToken = `${viewId}:${zoneKey}`;
  const hovered = hoveredKey === hoverToken;
  const active = activeZoneKey === zoneKey;
  const style = getInteractiveStyle(status, hovered, active, statusMeta);
  const markerMeta = statusMeta[status] || statusMeta.unknown;
  const markerMetrics = getShapeMarkerMetrics(shape, markerScale);
  const markerOffset = getMarkerOffset(viewId, zoneKey);
  // إزاحات الضبط معرّفة بوحدات الـ viewBox المرجعي، فتُقاس مع المقياس.
  const markerCx = markerMetrics.cx + markerOffset.dx * markerScale;
  const markerCy = markerMetrics.cy + markerOffset.dy * markerScale;
  const markerStroke = active ? '#0f172a' : markerMeta.stroke;
  const markerStrokeWidth = (active ? 2.8 : 2) * markerScale;
  // النص الأبيض لا يُقرأ على الأصفر؛ نختار لون النص حسب سطوع الخلفية.
  const markerTextColor = markerMeta.textColor || '#ffffff';
  const markerFontSize = markerMetrics.r * 1.15;
  // هالة بيضاء تفصل العلامة عن خطوط رسم السيارة السوداء.
  const haloWidth = Math.max(1.5, 3 * markerScale);
  const sharedProps = {
    id: domId,
    role: interactive ? 'button' : undefined,
    tabIndex: interactive ? 0 : -1,
    onMouseEnter: interactive ? () => setHoveredKey(hoverToken) : undefined,
    onMouseLeave: interactive ? () => setHoveredKey(null) : undefined,
    onFocus: interactive ? () => setHoveredKey(hoverToken) : undefined,
    onBlur: interactive ? () => setHoveredKey(null) : undefined,
    onClick: interactive ? () => onPartSelect(zoneKey) : undefined,
    onKeyDown: interactive
      ? (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onPartSelect(zoneKey);
          }
        }
      : undefined,
    style: { cursor: interactive ? 'pointer' : 'default' },
    fill: style.fill,
    fillOpacity: style.fillOpacity,
    stroke: style.stroke,
    strokeOpacity: style.strokeOpacity,
    strokeWidth: style.strokeWidth,
    strokeLinejoin: 'round',
    vectorEffect: 'non-scaling-stroke',
  };

  if (shape.type === 'polygon') {
    return (
      <>
        <polygon points={shape.points} {...sharedProps}>
          <title>{zoneKey}</title>
        </polygon>
        <g pointerEvents="none">
          <circle
            cx={markerCx}
            cy={markerCy}
            r={markerMetrics.r + haloWidth}
            fill="#ffffff"
            opacity={0.92}
          />
          <circle
            cx={markerCx}
            cy={markerCy}
            r={markerMetrics.r}
            fill={markerMeta.fill}
            stroke={markerStroke}
            strokeWidth={markerStrokeWidth}
            opacity={1}
          />
          <text
            x={markerCx}
            y={markerCy}
            transform={mirrored ? `translate(${markerCx * 2} 0) scale(-1 1)` : undefined}
            textAnchor="middle"
            dominantBaseline="central"
            fill={markerTextColor}
            fontWeight="800"
            fontSize={markerFontSize}
            style={{ paintOrder: 'stroke' }}
          >
            {statusNumber}
          </text>
        </g>
      </>
    );
  }

  return (
    <>
      <rect
        x={shape.x}
        y={shape.y}
        width={shape.width}
        height={shape.height}
        rx={Math.min(shape.width, shape.height) * 0.18}
        ry={Math.min(shape.width, shape.height) * 0.18}
        transform={mirrored ? `translate(${shape.x * 2 + shape.width} 0) scale(-1 1)` : undefined}
        {...sharedProps}
      >
        <title>{zoneKey}</title>
      </rect>
      <g pointerEvents="none">
        <circle
          cx={markerCx}
          cy={markerCy}
          r={markerMetrics.r + haloWidth}
          fill="#ffffff"
          opacity={0.92}
        />
        <circle
          cx={markerCx}
          cy={markerCy}
          r={markerMetrics.r}
          fill={markerMeta.fill}
          stroke={markerStroke}
          strokeWidth={markerStrokeWidth}
          opacity={1}
        />
        <text
          x={markerCx}
          y={markerCy}
          transform={mirrored ? `translate(${markerCx * 2} 0) scale(-1 1)` : undefined}
          textAnchor="middle"
          dominantBaseline="central"
          fill={markerTextColor}
          fontWeight="800"
          fontSize={markerFontSize}
          style={{ paintOrder: 'stroke' }}
        >
          {statusNumber}
        </text>
      </g>
    </>
  );
}

function InteractiveRectView({
  title,
  viewId,
  viewBox,
  silhouette,
  parts,
  zoneStates,
  zoneResolver,
  onPartSelect,
  activeZoneKey,
  hoveredKey,
  setHoveredKey,
  mirrored = false,
  statusMeta,
  statusNumbers = {},
}) {
  // حجم العلامة يتناسب مع مقاس الـ viewBox حتى تظهر بنفس الحجم البصري في كل الأنواع.
  const markerScale = getMarkerScale(viewBox);

  return (
    <ViewCard title={title}>
      <div className="relative h-[180px] overflow-hidden rounded-xl bg-white">
        <svg viewBox={viewBox} className={`absolute inset-0 h-full w-full ${mirrored ? '-scale-x-100' : ''}`}>
          <g id={`${viewId}-silhouette`}>{silhouette}</g>
          <g id={`${viewId}-parts`}>
            {parts.map((shape) => {
              const zoneKey = zoneResolver(shape.slot);
              return (
                <InteractiveShape
                  key={`${shape.slot}-${zoneKey}`}
                  shape={shape.type ? shape : { ...shape, type: 'rect' }}
                  zoneKey={zoneKey}
                  viewId={viewId}
                  statusNumbers={statusNumbers}
                  markerScale={markerScale}
                  zoneStates={zoneStates}
                  hoveredKey={hoveredKey}
                  setHoveredKey={setHoveredKey}
                  activeZoneKey={activeZoneKey}
                  onPartSelect={onPartSelect}
                  mirrored={mirrored}
                  statusMeta={statusMeta}
                />
              );
            })}
          </g>
        </svg>
      </div>
    </ViewCard>
  );
}

function SedanReferenceView({
  title,
  viewId,
  imageSrc = '/sedan.svg',
  mirrored = false,
  zoneStates,
  zoneResolver,
  onPartSelect,
  activeZoneKey,
  hoveredKey,
  setHoveredKey,
  statusMeta,
  statusNumbers = {},
}) {
  // حجم العلامة يتناسب مع مقاس الـ viewBox حتى تظهر بنفس الحجم البصري في كل الأنواع.
  const markerScale = getMarkerScale(SEDAN_SVG_VIEWBOX);

  return (
    <ViewCard title={title}>
      <div className="relative h-[190px] overflow-hidden rounded-xl bg-white">
        <svg
          viewBox={SEDAN_SVG_VIEWBOX}
          className={`absolute inset-0 h-full w-full ${mirrored ? '-scale-x-100' : ''}`}
          preserveAspectRatio="xMidYMid meet"
          aria-label={title}
        >
          <g id={`${viewId}-illustration`}>
            <image href={imageSrc} x="0" y="0" width="394.021" height="168.064" preserveAspectRatio="xMidYMid meet" />
          </g>
          <g id={`${viewId}-parts`}>
            {Object.entries(SEDAN_SIDE_PANELS)
              .filter(([slot]) => !SIDE_EXCLUDED_SLOTS.has(slot))
              .map(([slot, points]) => {
              const zoneKey = zoneResolver(slot);
              return (
                <InteractiveShape
                  key={`${slot}-${zoneKey}`}
                  shape={{ type: 'polygon', points }}
                  zoneKey={zoneKey}
                  viewId={viewId}
                  statusNumbers={statusNumbers}
                  markerScale={markerScale}
                  zoneStates={zoneStates}
                  hoveredKey={hoveredKey}
                  setHoveredKey={setHoveredKey}
                  activeZoneKey={activeZoneKey}
                  onPartSelect={onPartSelect}
                  mirrored={mirrored}
                  statusMeta={statusMeta}
                />
              );
            })}
          </g>
        </svg>
      </div>
    </ViewCard>
  );
}

function SvgReferenceView({
  title,
  viewId,
  imageSrc,
  viewBox = REFERENCE_SVG_VIEWBOX,
  imageWidth = 440,
  imageHeight = 180,
  imagePreserveAspectRatio = 'none',
  zoneStates,
  parts,
  zoneResolver,
  onPartSelect,
  activeZoneKey,
  hoveredKey,
  setHoveredKey,
  mirrored = false,
  statusMeta,
  statusNumbers = {},
}) {
  // حجم العلامة يتناسب مع مقاس الـ viewBox حتى تظهر بنفس الحجم البصري في كل الأنواع.
  const markerScale = getMarkerScale(viewBox);

  return (
    <ViewCard title={title}>
      <div className="relative h-[190px] overflow-hidden rounded-xl bg-white">
        <svg
          viewBox={viewBox}
          className={`absolute inset-0 h-full w-full ${mirrored ? '-scale-x-100' : ''}`}
          preserveAspectRatio="xMidYMid meet"
          aria-label={title}
        >
          <g id={`${viewId}-illustration`}>
            <image href={imageSrc} x="0" y="0" width={imageWidth} height={imageHeight} preserveAspectRatio={imagePreserveAspectRatio} />
          </g>
          <g id={`${viewId}-parts`}>
            {parts.map((shape) => {
              const zoneKey = zoneResolver(shape.slot);
              return (
                <InteractiveShape
                  key={`${shape.slot}-${zoneKey}`}
                  shape={shape.type ? shape : { ...shape, type: 'rect' }}
                  zoneKey={zoneKey}
                  viewId={viewId}
                  statusNumbers={statusNumbers}
                  markerScale={markerScale}
                  zoneStates={zoneStates}
                  hoveredKey={hoveredKey}
                  setHoveredKey={setHoveredKey}
                  activeZoneKey={activeZoneKey}
                  onPartSelect={onPartSelect}
                  mirrored={mirrored}
                  statusMeta={statusMeta}
                />
              );
            })}
          </g>
        </svg>
      </div>
    </ViewCard>
  );
}

export default function BodyDamageDiagram({
  bodyStyle = 'sedan',
  items = [],
  values = {},
  title = 'المؤشر المرئي للبودي',
  onPartSelect,
  activeZoneKey = null,
  resultOptions = DEFAULT_BODY_RESULT_OPTIONS,
  showLegend = true,
  showZoneSummary = true,
  preferRasterAssets = false,
}) {
  const resolvedStyle = STYLE_LABELS[bodyStyle] ? bodyStyle : 'sedan';
  const statusMeta = useMemo(() => {
    const next = { ...STATUS_META };

    (resultOptions || []).forEach((option) => {
      const key = String(option?.value || '').trim();
      if (!key) return;

      const fallback = next[key] || STATUS_META.unknown;
      const fill = option.bgColor || fallback.fill;
      next[key] = {
        ...fallback,
        label: option.label || fallback.label || key,
        fill,
        stroke: option.borderColor || fallback.stroke,
        baseOpacity: fallback.baseOpacity,
        textColor: readableTextColor(fill, fallback.textColor),
      };

      next[key.toLowerCase()] = next[key];
    });

    return next;
  }, [resultOptions]);
  // رقم كل حالة (جيد = 1، خدش = 2 ...) — نفس الرقم يظهر في الدليل وعلى الأجزاء.
  const statusNumbers = useMemo(() => buildResultNumberMap(resultOptions), [resultOptions]);
  const legendEntries = useMemo(() => getNumberedResultOptions(resultOptions), [resultOptions]);
  const legendKeys = useMemo(() => {
    const keys = legendEntries
      .map((option) => String(option.value || '').trim())
      .flatMap((key) => [key, key.toLowerCase()]);
    return [...new Set([...keys, 'unknown'])];
  }, [legendEntries]);
  const statusRankMap = useMemo(() => {
    // نفس ترتيب الخطورة المعروض: جيد ← خدش ← ضرر ← مرشوش ← مسمكر ← مبدل ← تالف
    const base = {
      unknown: 0,
      good: 1,
      scratch: 2,
      damage: 3,
      sprayed: 4,
      riveted: 5,
      replaced: 6,
      defect: 7,
    };
    let nextRank = 8;

    legendKeys.forEach((key) => {
      if (base[key] === undefined) {
        base[key] = nextRank;
        nextRank += 1;
      }
    });

    return base;
  }, [legendKeys]);
  const zoneStates = getZoneStateMap(items, values, resolvedStyle, statusMeta, statusRankMap);
  const zoneNumbers = useMemo(() => {
    const keys = [];

    items.forEach((item) => {
      const normalized = normalizeZoneKeyForStyle(item?.diagram_zone_key, resolvedStyle);
      if (normalized && !keys.includes(normalized)) {
        keys.push(normalized);
      }
    });

    return keys.reduce((acc, key, index) => {
      acc[key] = index + 1;
      return acc;
    }, {});
  }, [items, resolvedStyle]);
  const sideLayout = getSideLayout(resolvedStyle);
  const cargoZone = cargoZoneForStyle(resolvedStyle);
  const [hoveredKey, setHoveredKey] = useState(null);
  const numberedZoneRows = useMemo(() => {
    const rows = [];

    items.forEach((item) => {
      const rawZone = item?.diagram_zone_key;
      const zoneKey = normalizeZoneKeyForStyle(rawZone, resolvedStyle);
      if (!zoneKey) return;

      if (rows.some((row) => row.zoneKey === zoneKey)) return;

      const statusKey = zoneStates[zoneKey] || 'unknown';
      const meta = statusMeta[statusKey] || statusMeta.unknown;

      rows.push({
        zoneKey,
        number: zoneNumbers[zoneKey] || rows.length + 1,
        statusNumber: statusNumbers[statusKey] || null,
        name: item?.name || zoneKey,
        statusKey,
        statusLabel: meta.label,
        statusColor: meta.fill,
        statusBorder: meta.stroke,
      });
    });

    return rows.sort((a, b) => a.number - b.number);
  }, [items, resolvedStyle, zoneNumbers, statusNumbers, zoneStates, statusMeta]);

  const styleAssets = useMemo(() => {
    const assets = STYLE_VIEW_REFERENCE_ASSETS[resolvedStyle] || {};
    if (!preferRasterAssets) return assets;

    return Object.fromEntries(
      Object.entries(assets).map(([key, asset]) => [key, resolveAssetForMode(asset, true)]),
    );
  }, [resolvedStyle, preferRasterAssets]);
  const frontReferenceAsset = styleAssets.front || null;
  const rearReferenceAsset = styleAssets.rear || null;
  const topReferenceAsset = styleAssets.top || null;
  const leftReferenceAsset = styleAssets.left || null;
  const rightReferenceAsset = styleAssets.right || null;

  const topParts = useMemo(() => {
    if (resolvedStyle === 'trailer') {
      return polygonMapToShapes(TRAILER_TOP_POLYGONS);
    }

    if (resolvedStyle === 'box_truck') {
      return polygonMapToShapes(TRUCK_TOP_POLYGONS);
    }

    if (resolvedStyle === 'chassis_cab') {
      return polygonMapToShapes(CHASSIS_TOP_POLYGONS);
    }

    if (resolvedStyle === 'pickup') {
      return polygonMapToShapes(PICKUP_TOP_POLYGONS);
    }

    if (resolvedStyle === 'van') {
      return polygonMapToShapes(VAN_TOP_POLYGONS);
    }

    if (resolvedStyle === 'suv') {
      return polygonMapToShapes(SUV_TOP_POLYGONS);
    }

    if (resolvedStyle === 'hatchback') {
      return polygonMapToShapes(HATCHBACK_TOP_POLYGONS);
    }

    const referenceAsset =
      resolvedStyle === 'coupe'
        ? topReferenceAsset
        : resolvedStyle === 'sedan'
          ? topReferenceAsset
          : resolvedStyle === 'hatchback'
            ? topReferenceAsset
            : resolvedStyle === 'pickup'
              ? topReferenceAsset
              : resolvedStyle === 'van'
                ? topReferenceAsset
                : resolvedStyle === 'suv'
                  ? topReferenceAsset
            : null;

    if (referenceAsset) {
      return polygonMapToShapes(
        scalePolygonMap(
          TOP_POLYGONS,
          referenceAsset.width,
          referenceAsset.height,
          COUPE_TOP_BASE_SIZE.width,
          COUPE_TOP_BASE_SIZE.height,
        ),
      );
    }

    return polygonMapToShapes(TOP_POLYGONS);
  }, [resolvedStyle, topReferenceAsset]);

  const frontParts = useMemo(() => {
    if (resolvedStyle === 'trailer') {
      return polygonMapToShapes(TRAILER_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'box_truck') {
      return polygonMapToShapes(TRUCK_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'chassis_cab') {
      return polygonMapToShapes(CHASSIS_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'pickup') {
      return polygonMapToShapes(PICKUP_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'van') {
      return polygonMapToShapes(VAN_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'suv') {
      return polygonMapToShapes(SUV_FRONT_POLYGONS);
    }

    if (resolvedStyle === 'hatchback') {
      return polygonMapToShapes(HATCHBACK_FRONT_POLYGONS);
    }

    const referenceAsset =
      resolvedStyle === 'coupe'
        ? frontReferenceAsset
        : resolvedStyle === 'sedan'
          ? frontReferenceAsset
          : resolvedStyle === 'hatchback'
            ? frontReferenceAsset
            : resolvedStyle === 'pickup'
              ? frontReferenceAsset
              : resolvedStyle === 'van'
                ? frontReferenceAsset
                : resolvedStyle === 'suv'
                  ? frontReferenceAsset
            : null;

    if (referenceAsset) {
      return polygonMapToShapes(
        scalePolygonMap(
          FRONT_POLYGONS,
          referenceAsset.width,
          referenceAsset.height,
          COUPE_FRONT_BASE_SIZE.width,
          COUPE_FRONT_BASE_SIZE.height,
        ),
      );
    }

    return polygonMapToShapes(FRONT_POLYGONS);
  }, [resolvedStyle, frontReferenceAsset]);

  const rearParts = useMemo(() => {
    if (resolvedStyle === 'trailer') {
      return polygonMapToShapes(TRAILER_REAR_POLYGONS);
    }

    if (resolvedStyle === 'box_truck') {
      return polygonMapToShapes(TRUCK_REAR_POLYGONS);
    }

    if (resolvedStyle === 'chassis_cab') {
      return polygonMapToShapes(CHASSIS_REAR_POLYGONS);
    }

    if (resolvedStyle === 'pickup') {
      return polygonMapToShapes(PICKUP_REAR_POLYGONS);
    }

    if (resolvedStyle === 'van') {
      return polygonMapToShapes(VAN_REAR_POLYGONS);
    }

    if (resolvedStyle === 'suv') {
      return polygonMapToShapes(SUV_REAR_POLYGONS);
    }

    if (resolvedStyle === 'hatchback') {
      return polygonMapToShapes(HATCHBACK_REAR_POLYGONS);
    }

    const referenceAsset =
      resolvedStyle === 'coupe'
        ? rearReferenceAsset
        : resolvedStyle === 'sedan'
          ? rearReferenceAsset
          : resolvedStyle === 'hatchback'
            ? rearReferenceAsset
            : resolvedStyle === 'pickup'
              ? rearReferenceAsset
              : resolvedStyle === 'van'
                ? rearReferenceAsset
                : resolvedStyle === 'suv'
                  ? rearReferenceAsset
            : null;

    if (referenceAsset) {
      return polygonMapToShapes(
        scalePolygonMap(
          REAR_POLYGONS,
          referenceAsset.width,
          referenceAsset.height,
          COUPE_REAR_BASE_SIZE.width,
          COUPE_REAR_BASE_SIZE.height,
        ),
      );
    }

    return polygonMapToShapes(REAR_POLYGONS);
  }, [resolvedStyle, rearReferenceAsset]);
  const sideParts = useMemo(() => layoutToRectParts(sideLayout, 440, 180), [sideLayout]);
  const sidePartsFiltered = useMemo(
    () => sideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [sideParts],
  );
  const coupeSideParts = useMemo(() => {
    if (resolvedStyle === 'coupe' && leftReferenceAsset) {
      return polygonMapToShapes(
        scalePolygonMap(
          COUPE_SIDE_POLYGONS,
          leftReferenceAsset.width,
          leftReferenceAsset.height,
          COUPE_SIDE_BASE_SIZE.width,
          COUPE_SIDE_BASE_SIZE.height,
        ),
      );
    }

    return polygonMapToShapes(COUPE_SIDE_POLYGONS);
  }, [resolvedStyle, leftReferenceAsset]);
  const coupeSidePartsFiltered = useMemo(
    () => coupeSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [coupeSideParts],
  );
  const sedanSideParts = useMemo(() => {
    if (resolvedStyle === 'sedan' && leftReferenceAsset) {
      return polygonMapToShapes(
        scalePolygonMap(
          SEDAN_SIDE_PANELS,
          leftReferenceAsset.width,
          leftReferenceAsset.height,
          394.021,
          168.064,
        ),
      );
    }

    return polygonMapToShapes(SEDAN_SIDE_PANELS);
  }, [resolvedStyle, leftReferenceAsset]);
  const sedanSidePartsFiltered = useMemo(
    () => sedanSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [sedanSideParts],
  );
  const trailerSideParts = useMemo(() => {
    if (resolvedStyle === 'trailer' && leftReferenceAsset) {
      return layoutToRectParts(TRAILER_SIDE_LAYOUT, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset]);
  const trailerRightSideParts = useMemo(() => {
    if (resolvedStyle === 'trailer' && rightReferenceAsset) {
      return layoutToRectParts(
        mirrorSideLayout(TRAILER_SIDE_LAYOUT),
        rightReferenceAsset.width,
        rightReferenceAsset.height,
      );
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset]);
  const truckSideParts = useMemo(() => {
    if (resolvedStyle === 'box_truck' && leftReferenceAsset) {
      return layoutToRectParts(TRUCK_SIDE_LAYOUT, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset]);
  const truckRightSideParts = useMemo(() => {
    if (resolvedStyle === 'box_truck' && rightReferenceAsset) {
      return layoutToRectParts(
        mirrorSideLayout(TRUCK_SIDE_LAYOUT),
        rightReferenceAsset.width,
        rightReferenceAsset.height,
      );
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset]);
  const chassisSideParts = useMemo(() => {
    if (resolvedStyle === 'chassis_cab' && leftReferenceAsset) {
      return layoutToRectParts(CHASSIS_SIDE_LAYOUT, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset]);
  const chassisRightSideParts = useMemo(() => {
    if (resolvedStyle === 'chassis_cab' && rightReferenceAsset) {
      return layoutToRectParts(
        mirrorSideLayout(CHASSIS_SIDE_LAYOUT),
        rightReferenceAsset.width,
        rightReferenceAsset.height,
      );
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset]);
  const hatchbackSideParts = useMemo(() => {
    if (resolvedStyle === 'hatchback' && leftReferenceAsset) {
      return layoutToRectParts(sideLayout, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset, sideLayout]);
  const hatchbackSidePartsFiltered = useMemo(
    () => hatchbackSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [hatchbackSideParts],
  );
  const hatchbackRightSideParts = useMemo(() => {
    if (resolvedStyle === 'hatchback' && rightReferenceAsset) {
      return layoutToRectParts(mirrorSideLayout(sideLayout), rightReferenceAsset.width, rightReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset, sideLayout]);
  const hatchbackRightSidePartsFiltered = useMemo(
    () => hatchbackRightSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [hatchbackRightSideParts],
  );
  const pickupSideParts = useMemo(() => {
    if (resolvedStyle === 'pickup' && leftReferenceAsset) {
      return layoutToRectParts(sideLayout, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset, sideLayout]);
  const pickupSidePartsFiltered = useMemo(
    () => pickupSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [pickupSideParts],
  );
  const pickupRightSideParts = useMemo(() => {
    if (resolvedStyle === 'pickup' && rightReferenceAsset) {
      return layoutToRectParts(mirrorSideLayout(sideLayout), rightReferenceAsset.width, rightReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset, sideLayout]);
  const pickupRightSidePartsFiltered = useMemo(
    () => pickupRightSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [pickupRightSideParts],
  );
  const vanSideParts = useMemo(() => {
    if (resolvedStyle === 'van' && leftReferenceAsset) {
      return layoutToRectParts(sideLayout, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset, sideLayout]);
  const vanSidePartsFiltered = useMemo(
    () => vanSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [vanSideParts],
  );
  const vanRightSideParts = useMemo(() => {
    if (resolvedStyle === 'van' && rightReferenceAsset) {
      return layoutToRectParts(mirrorSideLayout(sideLayout), rightReferenceAsset.width, rightReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset, sideLayout]);
  const vanRightSidePartsFiltered = useMemo(
    () => vanRightSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [vanRightSideParts],
  );
  const suvSideParts = useMemo(() => {
    if (resolvedStyle === 'suv' && leftReferenceAsset) {
      return layoutToRectParts(sideLayout, leftReferenceAsset.width, leftReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, leftReferenceAsset, sideLayout]);
  const suvSidePartsFiltered = useMemo(
    () => suvSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [suvSideParts],
  );
  const suvRightSideParts = useMemo(() => {
    if (resolvedStyle === 'suv' && rightReferenceAsset) {
      return layoutToRectParts(mirrorSideLayout(sideLayout), rightReferenceAsset.width, rightReferenceAsset.height);
    }

    return [];
  }, [resolvedStyle, rightReferenceAsset, sideLayout]);
  const suvRightSidePartsFiltered = useMemo(
    () => suvRightSideParts.filter((shape) => !SIDE_EXCLUDED_SLOTS.has(shape.slot)),
    [suvRightSideParts],
  );
  const referenceAsset = preferRasterAssets
    ? rasterAssetPath(getBodyStyleReferenceAsset(resolvedStyle))
    : getBodyStyleReferenceAsset(resolvedStyle);
  const sedanSideReferenceAsset = preferRasterAssets ? '/sedan.png' : '/sedan.svg';

  return (
    <section className="rounded-2xl border bg-white p-4">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-lg font-bold">{title}</h3>
        <span className="rounded-full bg-slate-100 px-3 py-1 text-sm">شكل السيارة: {STYLE_LABELS[resolvedStyle]}</span>
      </div>

      <div className="grid gap-4 lg:grid-cols-[1.1fr_1.4fr]">
        <div className="space-y-4">
          {(() => {
            return topReferenceAsset ? (
            <SvgReferenceView
              title="المشهد العلوي"
              viewId="top"
              imageSrc={topReferenceAsset.src}
              viewBox={topReferenceAsset.viewBox}
              imageWidth={topReferenceAsset.width}
              imageHeight={topReferenceAsset.height}
              imagePreserveAspectRatio="none"
              parts={topParts}
              zoneStates={zoneStates}
              hoveredKey={hoveredKey}
              setHoveredKey={setHoveredKey}
              activeZoneKey={activeZoneKey}
              onPartSelect={onPartSelect}
              statusMeta={statusMeta}
              statusNumbers={statusNumbers}
              zoneResolver={(slot) => resolveTopZoneKey(slot, cargoZone)}
            />
            ) : (
            <InteractiveRectView
              title="المشهد العلوي"
              viewId="top"
              viewBox="0 0 340 160"
              silhouette={<TopSilhouette />}
              parts={topParts}
              zoneStates={zoneStates}
              hoveredKey={hoveredKey}
              setHoveredKey={setHoveredKey}
              activeZoneKey={activeZoneKey}
              onPartSelect={onPartSelect}
              statusMeta={statusMeta}
              statusNumbers={statusNumbers}
              zoneResolver={(slot) => resolveTopZoneKey(slot, cargoZone)}
            />
            );
          })()}

          <div className="grid grid-cols-2 gap-4">
            {(() => {
              return rearReferenceAsset ? (
              <SvgReferenceView
                title="الخلفي"
                viewId="rear"
                imageSrc={rearReferenceAsset.src}
                viewBox={rearReferenceAsset.viewBox}
                imageWidth={rearReferenceAsset.width}
                imageHeight={rearReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={rearParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => (slot === 'cargo' ? cargoZone : slot)}
              />
              ) : (
              <InteractiveRectView
                title="الخلفي"
                viewId="rear"
                viewBox="0 0 170 150"
                silhouette={<RearSilhouette />}
                parts={rearParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => (slot === 'cargo' ? cargoZone : slot)}
              />
              );
            })()}

            {(() => {
              return frontReferenceAsset ? (
              <SvgReferenceView
                title="الأمامي"
                viewId="front"
                imageSrc={frontReferenceAsset.src}
                viewBox={frontReferenceAsset.viewBox}
                imageWidth={frontReferenceAsset.width}
                imageHeight={frontReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={frontParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => slot}
              />
              ) : (
              <InteractiveRectView
                title="الأمامي"
                viewId="front"
                viewBox="0 0 170 150"
                silhouette={<FrontSilhouette />}
                parts={frontParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => slot}
              />
              );
            })()}
          </div>
        </div>

        <div className="space-y-4">
          {resolvedStyle === 'sedan' && leftReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={sedanSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={sedanSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
                mirrored
              />
            </>
          ) : resolvedStyle === 'trailer' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={trailerSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={trailerRightSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'box_truck' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={truckSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={truckRightSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'chassis_cab' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={chassisSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={chassisRightSideParts}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'sedan' ? (
            <>
              <SedanReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={sedanSideReferenceAsset}
                mirrored
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SedanReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={sedanSideReferenceAsset}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'hatchback' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={hatchbackSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={hatchbackRightSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'pickup' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={pickupSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={pickupRightSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'van' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={vanSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={vanRightSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'suv' && leftReferenceAsset && rightReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={suvSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={rightReferenceAsset.src}
                viewBox={rightReferenceAsset.viewBox}
                imageWidth={rightReferenceAsset.width}
                imageHeight={rightReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={suvRightSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : resolvedStyle === 'coupe' && leftReferenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={coupeSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={leftReferenceAsset.src}
                viewBox={leftReferenceAsset.viewBox}
                imageWidth={leftReferenceAsset.width}
                imageHeight={leftReferenceAsset.height}
                imagePreserveAspectRatio="none"
                parts={coupeSidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
                mirrored
              />
            </>
          ) : referenceAsset ? (
            <>
              <SvgReferenceView
                title="الجانب الأيسر"
                viewId="left-side"
                imageSrc={referenceAsset}
                parts={sidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
                mirrored
              />

              <SvgReferenceView
                title="الجانب الأيمن"
                viewId="right-side"
                imageSrc={referenceAsset}
                parts={sidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
              />
            </>
          ) : (
            <>
              <InteractiveRectView
                title="الجانب الأيسر"
                viewId="left-side"
                viewBox="0 0 440 180"
                silhouette={<SideSilhouette bodyStyle={resolvedStyle} />}
                parts={sidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'left', cargoZone)}
              />

              <InteractiveRectView
                title="الجانب الأيمن"
                viewId="right-side"
                viewBox="0 0 440 180"
                silhouette={<SideSilhouette bodyStyle={resolvedStyle} />}
                parts={sidePartsFiltered}
                zoneStates={zoneStates}
                hoveredKey={hoveredKey}
                setHoveredKey={setHoveredKey}
                activeZoneKey={activeZoneKey}
                onPartSelect={onPartSelect}
                statusMeta={statusMeta}
                statusNumbers={statusNumbers}
                zoneResolver={(slot) => resolveSideZoneKey(slot, 'right', cargoZone)}
                mirrored
              />
            </>
          )}
        </div>
      </div>

      {showLegend && (
        <div className="mt-4">
          <div className="mb-2 text-xs font-semibold text-slate-600">
            دليل الألوان والأرقام — الرقم الظاهر على كل جزء في الرسم يدل على حالته
          </div>
          <div className="flex flex-wrap gap-2 text-xs">
            {legendEntries.map((option) => {
              const meta = statusMeta[option.value] || statusMeta.unknown;
              return (
                <span
                  key={option.value}
                  className="inline-flex items-center gap-2 rounded-full border px-2 py-1"
                  style={{ borderColor: meta.stroke }}
                >
                  <span
                    className="inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold text-white"
                    style={{ backgroundColor: meta.fill, border: `1px solid ${meta.stroke}` }}
                  >
                    {option.number}
                  </span>
                  <span className="font-medium text-slate-700">{meta.label}</span>
                </span>
              );
            })}
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-2 py-1">
              <span
                className="inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold text-white"
                style={{ backgroundColor: statusMeta.unknown.fill, border: `1px solid ${statusMeta.unknown.stroke}` }}
              >
                ؟
              </span>
              <span className="font-medium text-slate-700">{statusMeta.unknown.label}</span>
            </span>
          </div>
        </div>
      )}

      {showZoneSummary && (
        <div className="mt-4 overflow-hidden rounded-xl border border-slate-200">
          <div className="bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-700">تفصيل الأجزاء (الجزء ↔ رقم الحالة ↔ الحالة)</div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-slate-200 text-sm">
              <thead className="bg-white text-slate-600">
                <tr>
                  <th className="px-3 py-2 text-right font-semibold">رقم الحالة</th>
                  <th className="px-3 py-2 text-right font-semibold">الجزء</th>
                  <th className="px-3 py-2 text-right font-semibold">الحالة</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {numberedZoneRows.map((row) => {
                  const isActive = activeZoneKey === row.zoneKey;
                  return (
                    <tr
                      key={row.zoneKey}
                      className={`transition ${isActive ? 'bg-sky-50' : 'hover:bg-slate-50'} ${onPartSelect ? 'cursor-pointer' : ''}`}
                      onClick={onPartSelect ? () => onPartSelect(row.zoneKey) : undefined}
                    >
                      <td className="px-3 py-2">
                        <span
                          className="inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold text-white"
                          style={{ backgroundColor: row.statusColor, border: `1px solid ${row.statusBorder}` }}
                        >
                          {row.statusNumber || '؟'}
                        </span>
                      </td>
                      <td className="px-3 py-2 font-medium text-slate-700">{row.name}</td>
                      <td className="px-3 py-2">
                        <span
                          className="inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-medium"
                          style={{ borderColor: row.statusBorder, color: row.statusBorder, backgroundColor: `${row.statusColor}22` }}
                        >
                          <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: row.statusColor }} />
                          {row.statusLabel}
                        </span>
                      </td>
                    </tr>
                  );
                })}

                {numberedZoneRows.length === 0 && (
                  <tr>
                    <td colSpan={3} className="px-3 py-3 text-center text-slate-500">
                      لا توجد أجزاء بودي لعرضها.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
}
